var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('StudentManage',{staticClass:"my-3",attrs:{"can-edit-state":true,"can-reset-password":true,"college-id":_vm.collegeId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }